import { ApiError } from "@/lib/api";

const PUBLIC_CODES = new Set([
  "unauthorized", "forbidden", "business_required", "bad_request",
  "dependency_unavailable", "dependency_conflict",
]);

export function installationPreviewError(cause: unknown): string {
  const message = "The installation plan could not be prepared.";
  const signIn = "Sign out and sign in to Console again before reviewing installation.";
  if (cause instanceof Error && cause.message === "A session CSRF token is required for this operation.") {
    return `${message} (session_csrf_missing) ${signIn}`;
  }
  if (cause instanceof ApiError && Number.isInteger(cause.status) && cause.status >= 400 && cause.status <= 599) {
    // Never render raw response bodies, exception messages or unknown codes.
    const code = cause.code && PUBLIC_CODES.has(cause.code) ? ` · ${cause.code}` : "";
    let guidance = "Review the selected apps and try again.";
    if (cause.status === 401) guidance = signIn;
    else if (cause.code === "business_required") guidance = "An active Business plan is required for this organization.";
    else if (cause.code === "dependency_unavailable") guidance = "A required published version is unavailable to this organization.";
    else if (cause.code === "dependency_conflict") guidance = "A required dependency has a version, app scope or enablement conflict.";
    return `${message} (${cause.status}${code}) ${guidance}`;
  }
  return `${message} Review the selected apps and try again.`;
}

export function directInstallationError(cause: unknown): string {
  if (cause instanceof ApiError && cause.status === 409) {
    return "The installation plan changed before it could be applied. Check Installed extensions before starting a fresh review.";
  }
  if (cause instanceof ApiError && cause.status === 401) {
    return "The installation could not be confirmed (401). Sign out and sign in to Console again, then check Installed extensions before retrying.";
  }
  if (cause instanceof ApiError && cause.status === 403 && cause.code === "business_required") {
    return "The installation could not be confirmed (403 · business_required). An active Business plan is required for this organization; check Installed extensions before retrying.";
  }
  if (cause instanceof ApiError && Number.isInteger(cause.status) && cause.status >= 400 && cause.status <= 599) {
    return `The installation could not be confirmed (${cause.status}). Check Installed extensions before trying again.`;
  }
  if (cause instanceof Error && cause.message === "A session CSRF token is required for this operation.") {
    return "The installation could not be confirmed (session_csrf_missing). Sign out and sign in to Console again, then check Installed extensions before retrying.";
  }
  return "The installation could not be confirmed. Check Installed extensions before trying again.";
}
